<script>
import { mapState, mapActions } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { debounce } from 'vue-debounce'
import { id } from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import axios from 'axios'
import PaginationCustom from '@/components/table/Pagination.vue'
import Permohonan from '@/components/mppd/PermohonanV2.vue'

const baseURL = process.env.VUE_APP_BASE_URL

export default {
   name: 'MppdV2',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      SweetModal,
      VuePdfApp,
      Permohonan,
      vSelect,
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         loading: true,
         filterDateLang: id,
         profesiList: [],
         kategoriFasyankesList: [],
         options: {
            jenis: [
               { value: null, text: '-' },
               { value: 'Baru', text: 'Baru' },
               { value: 'Perpanjangan', text: 'Perpanjangan' },
            ],
         },
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
            filter: {
               tanggal_awal: null,
               tanggal_akhir: null,
               jenis: null,
               profesi: null,
               kategori_fasyankes_id: null,
            },
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         isFilterOpen: false,
         columns: [

            {
               label: 'Pemohon',
               field: 'nama_pemohon',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'SIP',
               field: 'sip',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Register',
               field: 'register',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Fasyankes',
               field: 'fasyankes',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center align-middle',
            },
         ],
      }
   },
   computed: {
      ...mapState({
         myData: state => state.MppdV2.items,
         myCount: state => state.MppdV2.countAll,
      }),
      optionsProfesi() {
         return [{ value: null, text: '-' }, ...this.profesiList.map(item => ({ value: item, text: item }))]
      },
      optionsKategoriFasyankes() {
         return [{ value: null, text: '-' }, ...this.kategoriFasyankesList.map(item => ({ value: item.id, text: item.nama || item.name }))]
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.getProfesi()
      this.getKategoriFasyankes()
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'MppdV2/getData',
         getDataDetail: 'MppdV2/getDetail',
         cetakIzin: 'MppdV2/cetakIzin',
         cetakPermohonan: 'MppdV2/cetakPermohonan',
      }),
      onPermohonanDetail(idIzin) {
         this.getDataDetail(idIzin).then(() => {
            this.$bvModal.show('modal-proses')
         }, () => {

         })
      },
      onCetakIzin(idIzin) {
         this.loadingPdf = true
         this.cetakIzin(idIzin).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetak() {
         if (!this.isFilterOpen) {
            this.$toast.error('Aktifkan filter untuk mencetak PDF')
            return
         }
         this.loadingPdf = true
         const params = {}
         const tglAwal = this.formatDate(this.serverParams.filter.tanggal_awal)
         const tglAkhir = this.formatDate(this.serverParams.filter.tanggal_akhir)
         if (tglAwal) params.tanggal_awal = tglAwal
         if (tglAkhir) params.tanggal_akhir = tglAkhir
         if (this.serverParams.filter.jenis !== null) {
            params.jenis = this.serverParams.filter.jenis
         }
         if (this.serverParams.filter.profesi !== null) {
            params.profesi = this.serverParams.filter.profesi
         }
         if (this.serverParams.filter.kategori_fasyankes_id !== null) {
            params.kategori_fasyankes_id = this.serverParams.filter.kategori_fasyankes_id
         }
         if (this.searchTerm) {
            params.search = this.searchTerm
         }
         this.cetakPermohonan(params).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      formatDate(date) {
         if (!date) return null
         const d = new Date(date)
         const year = d.getFullYear()
         const month = String(d.getMonth() + 1).padStart(2, '0')
         const day = String(d.getDate()).padStart(2, '0')
         return `${year}-${month}-${day}`
      },
      getProfesi() {
         axios.get(`${baseURL}api/list/mppd/profesi`).then(res => {
            const data = Array.isArray(res.data) ? res.data : res.data.data || []
            this.profesiList = data
         })
      },
      getKategoriFasyankes() {
         axios.get(`${baseURL}api/list/mppd/fayankes`).then(res => {
            const data = Array.isArray(res.data) ? res.data : res.data.data || []
            this.kategoriFasyankesList = data
         })
      },
      onFilter() {
         this.serverParams.page = 1
         setTimeout(() => {
            this.loadItems()
         }, 100)
      },

      // VUE GOOD TABLE
      loadItems() {
         this.loading = true
         this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
      onShownCollapse() {
         this.isFilterOpen = true
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = new Date(new Date().getFullYear(), 0, 1)
         this.serverParams.filter.tanggal_akhir = new Date()
         this.serverParams.filter.jenis = null
         this.serverParams.filter.profesi = null
         this.serverParams.filter.kategori_fasyankes_id = null
         this.loadItems()
      },
      onHiddenCollapse() {
         this.isFilterOpen = false
         this.serverParams.page = 1
         this.serverParams.filter.tanggal_awal = null
         this.serverParams.filter.tanggal_akhir = null
         this.serverParams.filter.jenis = null
         this.serverParams.filter.profesi = null
         this.serverParams.filter.kategori_fasyankes_id = null
         this.loadItems()
      },
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data Permohonan MPP Digital V2.0">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search... (Nama pemohon, Jenis izin, No. Izin, No. Permohonan)"
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button
                        v-b-tooltip.hover.top="'Filter'"
                        v-b-toggle.collapse-filter
                        variant="outline-secondary"
                        size="sm"
                     >
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Cetak PDF'"
                        variant="outline-secondary"
                        size="sm"
                        @click="onCetak()"
                     >
                        <feather-icon icon="FileTextIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="onCetak()">
                           Cetak PDF
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>

            <!-- FILTER -->
            <b-col cols="12">
               <b-collapse id="collapse-filter" class="mt-2" @shown="onShownCollapse" @hidden="onHiddenCollapse">
                  <b-card class="border">
                     <b-row>
                        <b-col md="3">
                           <b-form-group label="Tanggal Terbit Awal" label-for="tanggal-awal">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_awal"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Tanggal Terbit Akhir" label-for="tanggal-akhir">
                              <datepicker
                                 v-model="serverParams.filter.tanggal_akhir"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Jenis Permohonan" label-for="jenis">
                              <v-select
                                 id="jenis"
                                 v-model="serverParams.filter.jenis"
                                 :options="options.jenis"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Jenis..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Profesi" label-for="profesi">
                              <v-select
                                 id="profesi"
                                 v-model="serverParams.filter.profesi"
                                 :options="optionsProfesi"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Profesi..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="3">
                           <b-form-group label="Kategori Fasyankes" label-for="kategori-fasyankes">
                              <v-select
                                 id="kategori-fasyankes"
                                 v-model="serverParams.filter.kategori_fasyankes_id"
                                 :options="optionsKategoriFasyankes"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Kategori..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
            <!-- FILTER -->

         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'register'">
                  <b>{{ (props.row.no_permohonan) }}</b>
                  <br>
                  <small>Tanggal : {{ props.row.tgl_pengajuan | moment("DD-MM-YYYY") }}</small>
               </span>

               <span v-if="props.column.field == 'nama_pemohon'">
                  <b>{{ props.row.pemohon_nama }}</b>
                  <br>
                  <small>NIK : {{ props.row.Pemohon.no_identitas }}</small>
                  <br>
                  <small>JK : {{ props.row.Pemohon.jenis_kelamin }}</small>
               </span>

               <span v-if="props.column.field == 'sip'">
                  <b>{{ props.row.jenis_izin_nama }}</b>
                  <br>
                  <small>Profesi : {{ props.row.List.profesi }}</small>
                  <br>
                  <small>Jenis : {{ props.row.jenis_permohonan }}</small>
                  <br>
                  <small>Periode : {{ props.row.mulai_berlaku | moment("DD-MM-YYYY") }} s/d {{ props.row.akhir_berlaku | moment("DD-MM-YYYY") }}</small>
                  <br>
                  <small>Terbit : {{ props.row.tgl_terbit | moment("DD-MM-YYYY") }}</small>
                  <br>
                  <small>Nomor : {{ props.row.no_izin }}</small>
               </span>

               <span v-if="props.column.field == 'fasyankes'">
                  <b>{{ props.row.fasyankes_nama }}</b>
                  <br>
                  <small>Kategori : {{ props.row.kategori_fasyankes_nama }}</small>
                  <br>
                  <small>Alamat : {{ props.row.fasyankes_alamat }}</small>
               </span>

               <span v-if="props.column.field == 'action'">
                  <b-button size="sm" block variant="outline-dark" @click="onPermohonanDetail(props.row.permohonan_izin_id)">
                     <feather-icon icon="ListIcon" class="mr-50" />
                     <small>Detail</small>
                  </b-button>
                  <b-button
                     v-if="props.row.s3_path"
                     size="sm"
                     block
                     variant="primary"
                     @click="onCetakIzin(props.row.id)"
                  >
                     <feather-icon icon="FileTextIcon" class="mr-50" />
                     <small>Cetak</small>
                  </b-button>
               </span>
               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-proses"
         scrollable
         size="xl"
         centered
         hide-footer
         title="Detail Permohonan"
      >
         <div style="height: 70vh;">
            <Permohonan />
         </div>
      </b-modal>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless>tr>td {
   border: none;
   padding: 0em;
}

.borderless>tr>td {
   border: none;
   padding: 0em;
}

table>tbody>tr>td>span>hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.hidden_header {
   display: none;
}
</style>
